import { createApp } from '@wu/widget-core';
import { AgeVerification } from './AgeVerification';
import { meta } from './meta';

const { alias, name } = meta;

export default createApp({ alias, name }, AgeVerification);
